import { useTranslation } from "react-i18next";

import { useTimeRemaining } from "@/components/campaign-card/campaign-time-remaining";

/**
 * The ticking time to the draw, in the shared countdown format (weeks/days as text, `hh : mm`
 * below a day, `mm : ss` below an hour). `overrun`: a draw time that has passed while the raffle is
 * still earning reads as a zero clock, never "Ended" — the lock/draw flip arrives on the stream.
 */
export const DrawCountdown = ({ date }: { date: Date }) => {
  const { t } = useTranslation();
  return (
    <div className="tabular-nums">{useTimeRemaining(date, t, true, true)}</div>
  );
};
